const postloadedToolbarTransitionDurationMs = 150;
const toolsTransition = "dibtjpwj9c";
const toolbarCls = "dibt6uvf8o";

export { postloadedToolbarTransitionDurationMs, toolbarCls, toolsTransition };
import "./molecule.toolbar.style.linaria.module.css";
//# sourceMappingURL=molecule.toolbar.style.js.map
